import React, { useEffect, useState } from "react";
import { Chip, makeStyles, Tooltip, useTheme } from "@material-ui/core";
import { getCookie, setCookie, eraseCookie } from "src/utils/utils";
import useRouteManager from "src/utils/customHook/useRouteManager";
import { useProfile } from "src/utils/customHook";
import { BROKERS } from "src/context/constants";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

interface MockToggleProps {}
const BetaChip: React.FC<MockToggleProps> = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [isBeta, setIsBeta] = useState(false);
  const { brokerNameOnURL } = useRouteManager();

  // useEffect(()=>{
  //   if (brokerNameOnURL?.toLowerCase() === BROKERS.bitkub.name) setIsBeta(true)
  // },[brokerNameOnURL])

  return (
    <div className={classes.root}>
      <Tooltip title="Finnize สำหรับ Bitkub ยังอยู่ในช่วง Beta" arrow>
        <Chip
          style={{
            backgroundColor: theme.palette.primary.main,
            visibility: isBeta ? "visible" : "hidden",
            color: "black",
            height: 24,
          }}
          label="beta"
        />
      </Tooltip>
    </div>
  );
};

export default BetaChip;
